import React from "react";
import { Link } from "react-router-dom";
import PolicyPage from "./PolicyPage";
import "../css/privacy.scss";

const sections = [
  {
    id: "information-we-collect",
    title: "Information we collect",
    content: (
      <>
        <p>
          We collect information that you provide when you place an order,
          create an account, contact our team or otherwise use DZCP HiFi. This
          may include your name, email address, telephone number, billing and
          delivery addresses, and order details.
        </p>
        <p>
          Payments are handled by our payment providers. We receive the details
          needed to confirm and manage a transaction, but we do not store your
          complete payment-card number.
        </p>
        <ul>
          <li>Account, contact, billing and shipping information</li>
          <li>Products viewed, orders placed and customer-service messages</li>
          <li>Device, browser, IP address and approximate location data</li>
          <li>Cookie preferences and website interaction information</li>
        </ul>
      </>
    ),
  },
  {
    id: "how-we-use-information",
    title: "How we use your information",
    content: (
      <>
        <p>
          We use personal information only where we have a valid reason to do
          so, including fulfilling our contract with you, complying with law,
          protecting our legitimate business interests or acting with your
          consent.
        </p>
        <ul>
          <li>Process payments, dispatch orders and provide delivery updates</li>
          <li>Respond to questions, returns, refunds and warranty requests</li>
          <li>Maintain accounts and remember customer preferences</li>
          <li>Prevent fraud, misuse and other security threats</li>
          <li>Improve our products, website performance and customer service</li>
          <li>Send marketing only where permitted and provide an opt-out</li>
        </ul>
      </>
    ),
  },
  {
    id: "cookies",
    title: "Cookies and similar technologies",
    content: (
      <>
        <p>
          Cookies are small files that help a website remember a browser or
          device. We use essential cookies for features such as the shopping
          cart, checkout and security. With your permission, we may also use
          analytics or advertising cookies to understand how the store is used.
        </p>
        <p>
          You can control non-essential cookies through the options offered on
          the website or in your browser. Blocking essential cookies may prevent
          parts of the store from working correctly.
        </p>
      </>
    ),
  },
  {
    id: "sharing-information",
    title: "When we share information",
    content: (
      <>
        <p>
          We do not sell your personal information. We share only the
          information required for trusted service providers to perform work on
          our behalf, such as payment processing, hosting, fraud prevention,
          order fulfilment, delivery, analytics and customer support.
        </p>
        <p>
          We may also disclose information when required by law, to enforce our
          terms, to protect customers and our business, or as part of a genuine
          merger, acquisition or business transfer. Providers must use the data
          only for the agreed service and protect it appropriately.
        </p>
      </>
    ),
  },
  {
    id: "international-transfers",
    title: "International data transfers",
    content: (
      <p>
        Our store, providers and customers may be located in different
        countries. When information is transferred internationally, we use
        contractual and technical safeguards required by applicable law. The
        privacy rules in a destination country may differ from those where you
        live.
      </p>
    ),
  },
  {
    id: "retention-security",
    title: "Retention and security",
    content: (
      <>
        <p>
          We keep personal information only for as long as needed to complete
          the purposes described here, maintain necessary business records,
          resolve disputes and meet tax, accounting or legal requirements.
        </p>
        <p>
          We use reasonable administrative, technical and physical safeguards
          to reduce the risk of loss, unauthorized access or misuse. No online
          service can guarantee absolute security, so please use a strong,
          unique password and contact us if you suspect unauthorized activity.
        </p>
      </>
    ),
  },
  {
    id: "your-rights",
    title: "Your privacy rights",
    content: (
      <>
        <p>
          Depending on where you live, you may ask to access, correct, delete or
          receive a copy of your personal information. You may also be able to
          restrict or object to certain processing and withdraw consent at any
          time.
        </p>
        <p>
          To make a request, email us using the address below. We may need to
          verify your identity before acting, and some records may be retained
          where the law requires it. You can unsubscribe from marketing at any
          time without affecting order-related messages.
        </p>
      </>
    ),
  },
  {
    id: "children-third-parties",
    title: "Children and third-party services",
    content: (
      <>
        <p>
          DZCP HiFi is intended for adults and we do not knowingly collect
          personal information from children under 16. Please contact us if you
          believe a child has provided information so that we can review and
          delete it where appropriate.
        </p>
        <p>
          Our website may link to services operated by other organizations.
          Their privacy practices are governed by their own notices, and we
          recommend reviewing those notices before submitting information.
        </p>
      </>
    ),
  },
  {
    id: "changes-contact",
    title: "Changes and contact details",
    content: (
      <>
        <p>
          We may update this policy as our services, technology or legal
          obligations change. The latest version will always appear on this
          page with its revision date.
        </p>
        <p>
          For privacy questions or requests, contact Mystron Technology Limited
          at <a href="mailto:support@dzcp896.com">support@dzcp896.com</a>, call
          +852 5436 7186, or use our <Link to="/contact">contact page</Link>.
        </p>
      </>
    ),
  },
];

function Privacy() {
  return (
    <PolicyPage
      className="privacy"
      title="Privacy Policy"
      summary="This policy explains what information DZCP HiFi collects, why we use it and the choices available to you."
      sections={sections}
    />
  );
}

export default Privacy;
